<template>
  <div class="apply">
    <Header title="缓考申请"></Header>
    <div class="apply-body">
      <div v-if="cj0704ids==''">
        <p class="apply-title">{{this.topInfo.courseName}}</p>
        <p class="apply-num">学时：{{this.topInfo.period}}</p>
        <p class="apply-num">学分：{{this.topInfo.credit}}</p>
      </div>

      <div class="apply-inputs">
        <div class="apply-input">
          <p><span style="color:red">*</span>申请原因</p>
          <input type="text" placeholder="请点击填写" v-model="reason"/>
        </div>


        <div class="apply-input" v-if="schoolCode=='12561' || schoolCode == '10537' || schoolCode == '10013'|| schoolCode === '10653'||schoolCode=='10848'||schoolCode=='10331'||schoolCode=='10488'">
          <p v-if="this.schoolCode=='12561'"><span style="color:red">*</span>证明材料</p>
          <p v-else><span style="color:red" v-if="!btfj">*</span>上传附件</p>
          <van-uploader v-if="this.schoolCode=='10013'"
            accept="*"
            v-model="fileList"
            :after-read="afterRead"
            :max-size="20 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
          <van-uploader v-else-if="this.schoolCode==='10653'||schoolCode==='10488'"
                        accept=".xls,.doc,.xlsx,.xlsx,.docx,.jpg,.XLS,.DOC,.XLSX,.DOCX,.JPG"
                        v-model="fileList"
                        :after-read="afterRead"
                        :max-size="20 * 1024 * 1024"
                        @oversize="onOversize"
                        :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
          <van-uploader v-else-if="this.schoolCode==='10848' "
                        accept=".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.pdf,.PDF"
                        v-model="fileList"
                        :after-read="afterRead"
                        :max-size="20 * 1024 * 1024"
                        @oversize="onOversize"
                        :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
          <van-uploader v-else
            v-model="fileList"
            :after-read="afterRead"
            :max-size="20 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
        </div>

        <div class="apply-input" v-if="schoolCode=='10331'">
          <p><span style="color:red" >*</span>手写签名</p>
          <van-uploader v-model="qmfileList"
                        :max-size="20 * 1024 * 1024"
                        @oversize="onOversize"
                        accept=".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.img,.IMG"
                        :max-count="1"
          > <div class="fujianImg"></div></van-uploader>
        </div>

        <div class="apply-input" v-show="schoolCode != '10537' && qycjlrrsh != '1'">
          <p><span style="color:red" v-if="schoolCode=='12561'">*</span>审核人</p>
          <input type="text" placeholder="请点击选择" @click="isPopShow()" v-model="person" readonly   :disabled="isApply"/>


          <i class="arrow"></i>
        </div>

        <div class="apply-input" v-show="schoolCode == '10294'">
          <p><span style="color:red">*</span>考试时间</p>
          <input type="text" placeholder="请点击选择" @click="showsj = !showsj" v-model="kssj" readonly/>
          <i class="arrow"></i>
        </div>
        <div class="apply-input" v-show="schoolCode == '10294'">
          <p><span style="color:red">*</span>联系电话</p>
          <input type="text" v-model="lxdh" placeholder="请填写联系电话">
        </div>

      </div>
    </div>
    <button class="apply-btn" @click="submitApply()">提交申请</button>

    <!-- 审核人popup -->
    <van-popup v-model="isShow" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="isShow = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button class="per-btn" ref="person" @click="personTap($event,index)" v-for="(item,index) in personList" :key="item.id">{{item.name}}</button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showsj" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" title="请选择" :formatter="timeFormatter" @confirm="sjConfirm" @cancel="showsj = false" />
    </van-popup>

    <div class="noteisDiv" v-if="this.schoolCode=='12561'">
      注意事项：
      <div class="noteisDiv-context">
         证明材料需上传清晰有效。<br>
         1、因病住院或急诊留院观察者，需提交医院证明；因公参加学校、学生所属二级学院的活动，需提交经学生所属二级学院教学院长签字的参加活动说明。<br>
         2、办理缓考手续的学生，可以参加新学期补考。<br>
         3、毕业设计和顶岗实习等实践教学环节不能申请缓考。<br>
         4、缓考必须于考试前申请办理方为有效。<br>
      </div>
    </div>
    <div class="noteisDiv" v-if="this.schoolCode=='10848'">
      <div style="color: red;">
         注:附件只能上传.jpg,.jpeg,.png,.pdf的格式
      </div>
    </div>
    <div class="noteisDiv" v-if="this.schoolCode=='10294'">
      <div style="color: red;">
        学生因特殊情况不能按期参加考核者，至少于考试前一天向所在学院提出申请，并附相关证明材料，经学院审核，教务处审批同意后，方可缓考，课程缓考以一次为限。缓考须随下学期初不及格课程的开学补考进行考核；未安排补考的课程，随下一年级相同课程免费跟班重修考核。补考成绩由平时成绩和补考卷面成绩组成，最高限 70 分。
      </div>
    </div>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  import {Dialog} from "vant";
  export default{
    data(){
      return{
        isShow:false,
        showsj:false,
        isApply:false,
        btfj:false,
        fjbxsc:'',
        issqhk:'',
        cjlrrshkz:'',
        fileList: [],
        qmfileList: [],
        file: {},
        topInfo:'',
        reason:'',
        personList:[
        {
          id:'',
          name:'全部',
          isBtn:0,
        }
        ],
        person:'',
        kssj:'',
        lxdh:'',
        currentDate: new Date(),
        personId:'',
        reset:"",
        resetId:'',
        schoolCode: sessionStorage.getItem("schoolCode"),
        jx0404idList:'',
        qycjlrrsh:'',
        cj0704ids:"",
      }
    },
    created(){

      this.jx0404idList = this.$route.query.jx0404idList;
      this.getPeople()
      if (this.schoolCode=='10653'){
        this.getsfcjshr(this.topInfo)
        this.reason=this.topInfo.reason
        console.log(this.topInfo,'dwdwadwadwa')
      }

      if (this.schoolCode=='10331'){
        this.cj0704ids=this.$route.query.cj0704ids
        if(this.cj0704ids!="" && this.cj0704ids!=undefined && this.cj0704ids!="undefined"){
        }
        else{
          this.cj0704ids="";
          this.topInfo = JSON.parse(this.$route.query.data);
        }
      }
      else{
        this.topInfo = JSON.parse(this.$route.query.data);
      }
      if(this.schoolCode=='10488'){
        this.btfj = true;
      }
    },
    methods:{
      resetCancel(){
        this.isShow= false
        this.person = this.reset
        this.personId = this.resetId
      },
      onOversize(file) {
          this.$toast.fail("文件大小不能超过10M");
      },
      afterRead(file) {
          // 此时可以自行将文件上传至服务器
          this.file = file.file;
      },
      async getPeople(){
        const params = {
          ywcode:'019',
          ywid:this.topInfo.jx0404id
        }
        const res = await Api.selectReviewerApi(params)
        let concatList = []
        res.data.forEach((item,index) => {
          concatList[index] = {
            name:item.userrealname,
            id:item.userid,
            isBtn:0,
          }
        });
        if(this.schoolCode=='10013' || this.schoolCode=='12561'){
          this.personList = [];
        }
        this.personList = this.personList.concat(concatList)
        if(this.schoolCode=='10294'){
          const Qyparams = {
            cj0704id:this.topInfo.cj0704id
          }
          const Qyztres = await Api.getSfqyCjllr(Qyparams)
          this.qycjlrrsh = Qyztres.qycjlrrsh;
        }
      },
      isPopShow(){
        this.isShow = !this.isShow
      },
      close(){
        this.isShow =false
      },
      async submitApply(){


        if(this.schoolCode=='10294'){
          if(this.kssj == ''){
            this.$toast.fail('请选择考试时间~');
            return;
          }
          if(this.lxdh == ''){
            this.$toast.fail('请填写联系电话~');
            return;
          }
        }
        if(this.reason == ''){
          this.$toast.fail('请填写申请原因~');
          return;
        }
        else if((this.schoolCode=='12561' || this.schoolCode == '10537'  || this.schoolCode == '10013'|| this.schoolCode === '10653'||this.schoolCode === '10848')&&this.fileList.length==0){
          if(this.schoolCode=='12561'){
            this.$toast.fail('请上传证明材料');
            return;
          }else if (this.schoolCode === '10653'||this.schoolCode === '10848'){
            if (!this.btfj){
              this.$toast.fail('请上传附件');
              return;
            }
          }else{
            this.$toast.fail('请上传附件');
            return;
          }
        }

        if(this.schoolCode=='10331'){
          if(this.qmfileList.length==0){
            this.$toast.fail('请上传手写签名');
            return;
          }
          else{
            let yxgs="jpg,JPG,jpeg,JPEG,png,PNG,img,IMG"
            var type=this.qmfileList[0].file.type
            let hzm=type.substring(type.lastIndexOf("/")+1)
            if(yxgs.indexOf(hzm)==-1){
              this.$toast("手写签名附件文件类型必须是.png,jpg,jpeg,img 中的一种")
              return
            }
          }
        }

        if(this.schoolCode=='12561'&&this.person==''){
            this.$toast.fail('请选择审核人');
            return;
        }
        else{
          const params = {
            cj0704id:this.topInfo.cj0704id,
            reason:this.reason,
            auditor:this.person == '全部' ? '' : this.personId,
            hksqfj:(this.schoolCode=='12561' || this.schoolCode=='10537' || this.schoolCode == '10013' || this.schoolCode === '10653'||this.schoolCode === '10848'||this.schoolCode === '10331'||this.schoolCode === '10488') ? this.file:'',
            jx0404idList:this.jx0404idList,
            kssj:this.kssj,
            lxdh:this.lxdh,
            fjbxsc:this.fjbxsc,
            issqhk:this.issqhk,
            cjlrrshkz:this.cjlrrshkz,
            cj0704hkid:(this.schoolCode === '10653'||this.schoolCode === '10488') ? this.topInfo.cj0704hkid:'',
            cj0704ids:this.schoolCode === '10331' ? this.cj0704ids:'',
            hksqqmfj:this.schoolCode === '10331' ? this.qmfileList[0].file:'',
            reApply:this.topInfo.reApply||''
          }
        /*  const res = await Api.slowExaminationSave(params)
          if(res.code!='0'){
            this.$toast(res.Msg)
          }
          if(res.code == '1'){
            this.$toast(res.Msg)
            setTimeout(()=>{
              this.$router.replace('/student/delayedExam');
            }, 800)
          }*/
          if (this.schoolCode==='10653'){
            Dialog.confirm({
              title: "提示",
              message: "请再次确定缓考申请填写是否无误，送审后将不能再进行修改；送审后请及时打印缓考申请表，按要求签字后于考试前送至教务处教学运行科。如确定无误请点击确定继续送审",
            })
              .then(() => {
                  const res = this.aaa(params)
                  console.log(res,'@@@@@@')
              })
              .catch(() => {
                // on cancel
              });
          }else {
            const res = await Api.slowExaminationSave(params)
            if(res.code!='0'){
              this.$toast(res.Msg)
            }
            if(res.code == '1'){
              this.$toast(res.Msg)
              setTimeout(()=>{
                this.$router.replace('/student/delayedExam');
              }, 800)
            }
          }


        }
      },
      async aaa(params){
        const res = await Api.slowExaminationSave(params)
        if(res.code!='0'){
          this.$toast(res.Msg)
        }
        if(res.code == '1'){
          this.$toast(res.Msg)
          setTimeout(()=>{
            this.$router.replace('/student/delayedExam');
          }, 800)
        }
      },
      personTap(e,res){
        let strList = []
        let idList = []
        if(this.personList[res].isBtn == 0){
          this.personList[res].isBtn = 1
          e.target.className = 'cur'
        }else if(this.personList[res].isBtn == 1){
          this.personList[res].isBtn = 0
          e.target.className = 'per-btn'
        }
        for(let i in this.personList){
          if(this.schoolCode!='10013' && this.schoolCode!='12561'){
            if(this.personList[res].name == '全部'){
              this.personList[i].isBtn = 0;
              this.personList[res].isBtn = 1
              this.$refs.person[res].className = 'cur'
              this.$refs.person[i].className = 'per-btn'
            }else{
              this.personList[0].isBtn = 0;
              this.$refs.person[0].className = 'per-btn'
            }
          }
          if(this.personList[i].isBtn == 1){
            strList = strList.concat(this.personList[i].name)
            idList = idList.concat(this.personList[i].id)
          }
        }
        this.reset = strList.toString();
        this.resetId = idList.toString();
      },
      timeFormatter(type, val) {
        if (type === 'year') {
          return val + '年'
        }
        if (type === 'month') {
          return val + '月'
        }
        if (type === 'day') {
          return val + '日'
        }
        return val
      },
      sjConfirm(val) {
        this.kssj = this.getTiem(val)
        this.showsj = false
      },
      getTiem(val) {
        const date = new Date(val)
        const y = date.getFullYear()
        const m = date.getMonth() + 1 > 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        const d = date.getDate() > 10 ? date.getDate() : '0' + date.getDate()
        return y + '-' + m + '-' + d
      },
      async getsfcjshr(){
        const res = await Api.querySfgxshrApi(this.topInfo)
        if (res.data.msg==='1'){
          this.isApply=true
        }
        if (res.data.fjbxsc==='1'){
          this.btfj=false
        }else {
          this.btfj=true
        }
        this.fjbxsc=res.data.fjbxsc
        this.issqhk=res.data.issqhk
        this.cjlrrshkz=res.data.cjlrrshkz
        this.fileList.push({
          url: res.data.filename,
          name: res.data.filepath
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.noteisDiv{
    padding-left: 20px;
    padding-right: 20px;
    .noteisDiv-context{
      padding-left: 10px;
      font-size: 13px;
    }
  }
  .fujianImg{
    background: url(../../../assets/images/fujian.png)no-repeat center;
    background-size: 18px 18px;width: 18px;height: 18px;
  }
  .van-cell--required::before{
    left:0px!important;
  }
  .scfj span{
    color:red!important;
    background-color: darkgreen;
    margin-left:-11px;
  }


  .apply-body{padding: 20px;}
  .apply-body .apply-title{font-size: 18px;color: @attendance-color-1;font-weight: 600;}
  .apply-body .apply-num{font-size: 14px;color: @attendance-color-2;margin-top: 8px;}
  .apply-inputs{margin-top: 17px;}
  .apply-inputs .apply-input{padding: 9px 0;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid @attendance-border-color-6;color: @attendance-color-1;}
  .apply-input input{flex: 1;text-align: right;color: @attendance-color-1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-left: 20px;}
  .apply-input input::placeholder{color: @attendance-background-color-2;font-size: 16px;}
  .apply .apply-btn{position: absolute;bottom: 20px;background-color: @attendance-background-color-1;padding: 11px 0;color: @attendance-color-3;border-radius: 3px;width: 90%;margin-left: 5%;}
  .apply-pop{
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    max-height: 40%;
    overflow-y: scroll;
  }
  .close-icon{background: url(../../../../static/img/close.png)no-repeat center;}
  .pop-title{display: flex;justify-content: space-between;
    padding: 13px;
    position: fixed;
    width: 100%;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;z-index: 9;}
  .pop-title i{width: 22px;height: 22px;background-size: 22px 22px;}
  .confirm-icon{background: url(../../../../static/img/confirm.png)no-repeat center;}
  .apply-pop .person{padding: 20px 20px 0;display: flex;flex-wrap: wrap;margin-top: 48px;}
  .person button{border-radius:3px;padding: 5px 15px;margin-right: 12px;margin-bottom: 15px;}
  .apply-pop .person .per-btn{background-color: @attendance-background-color-7;color: @attendance-background-color-1;}
  .person .cur{background-color: @attendance-background-color-1;color: @attendance-background-color-7;}
  .apply-input .arrow{background: url(../../../../static/img/arrow_r.png)no-repeat center;width: 13px;height: 13px;background-size: 13px 13px;margin-left: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/student/delayTest/delayApply.vue